const PRODUCT_QUERY_PARAM = 'contact_product';
const EVENT_QUERY_PARAM = 'contact_event';

function prefillContactProduct() {
  const params = new URLSearchParams(window.location.search);
  const productTitle = params.get(PRODUCT_QUERY_PARAM)?.trim();
  const eventTitle = params.get(EVENT_QUERY_PARAM)?.trim();

  if (!productTitle && !eventTitle) return;

  const textarea = document.querySelector('textarea[name="contact[body]"]');
  if (!(textarea instanceof HTMLTextAreaElement)) return;
  if (textarea.value.trim() !== '') return;

  textarea.value = productTitle ? `- ${productTitle}\n` : `- Event: ${eventTitle}\n`;
  textarea.dispatchEvent(new Event('input', { bubbles: true }));
  textarea.dispatchEvent(new Event('change', { bubbles: true }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', prefillContactProduct, { once: true });
} else {
  prefillContactProduct();
}
